module.exports = __webpack_public_path__ + "img/exam_jan_2025_6wrm47l3.779bf014.jpg";